export const roleDetailConstants = {
    ROLE_DETAIL_FETCHING: 'ROLE_DETAIL_FETCHING',
    ROLE_DETAIL_FETCHED: 'ROLE_DETAIL_FETCHED',
    GET_ROLEDETAIL: 'GET_ROLEDETAIL',
    GET_ROLEDETAIL_MENUID: 'GET_ROLEDETAIL_MENUID',
    GET_ROLEDETAILMENU: 'GET_ROLEDETAILMENU'
}